module.exports = __webpack_public_path__ + "img/info.d6ec6d4b.svg";